import type { FullAuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';

export interface CommunicationDto extends FullAuditedEntityDto<string> {
  message?: string;
  isActive: boolean;
  imageFileId?: number;
  imageUrl?: string;
  imageFileName?: string;
}

export interface CreateUpdateCommunicationDto {
  message?: string;
  isActive: boolean;
  imageFileId?: number;
}

export interface GetCommunicationsInput extends PagedAndSortedResultRequestDto {
  filter?: string;
}
